"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteMenu = exports.Autocomplete = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var AutocompleteContext = (0, react_1.createContext)(null);
var Autocomplete = function (_a) {
    var value = _a.value, children = _a.children, props = __rest(_a, ["value", "children"]);
    var _b = (0, react_1.useState)(false), show = _b[0], setMenu = _b[1];
    var onClose = function () {
        document.removeEventListener('click', onClose);
        closeMenu();
    };
    var addClickAway = debounce(function () {
        document.addEventListener('click', onClose);
    }, 300);
    var onFocus = function () {
        setMenu(true);
    };
    var onClick = function () {
        setMenu(true);
        addClickAway();
    };
    var closeMenu = function () { return setMenu(false); };
    var onSelect = function (value) {
        if (props.onChange) {
            props.onChange({ target: { value: value } });
        }
    };
    var inputProps = __assign({ onFocus: onFocus, onClick: onClick, value: value }, props);
    return (react_1.default.createElement(AutocompleteContext.Provider, { value: { show: show, onSelect: onSelect, value: [].concat(value), inputProps: inputProps } }, children));
};
exports.Autocomplete = Autocomplete;
var AutocompleteMenu = function (_a) {
    var children = _a.children;
    var ctx = (0, react_1.useContext)(AutocompleteContext);
    var _b = ctx, show = _b.show, inputProps = _b.inputProps, onSelect = _b.onSelect;
    return (react_1.default.createElement("div", { className: "position-relative" },
        react_1.default.createElement("input", __assign({}, inputProps)),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('position-absolute collapse w-100 mt-3', { show: show }) },
            react_1.default.createElement("ul", { className: "list-group" }, children(onSelect)))));
};
exports.AutocompleteMenu = AutocompleteMenu;
function debounce(fn, time) {
    if (time === void 0) { time = 0; }
    var timerId;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timerId);
        timerId = setTimeout(function () { return fn.apply(void 0, args); }, time);
    };
}
//# sourceMappingURL=Autocomplete.js.map